import { Table } from "antd";

const AntTable = ({
  loading,
  users,
  pagination,
  handleGetNext,
  columns,
  ref,
  tableScrollWidth = 1000,
}) => {
  const handleTableChange = (pagination) => {
    handleGetNext({
      pagination,
    });
  };

  return (
    <div>
      {/* <pre>{JSON.stringify(users, null, 2)}</pre> */}
      <Table
        ref={ref}
        columns={columns}
        rowKey="id"
        dataSource={users}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "100", "500"],
        }}
        loading={loading}
        scroll={{ x: tableScrollWidth }}
        onChange={handleTableChange}
        size="small"
        className="compact-table"
        tableLayout="fixed"
      />
    </div>
  );
};

export default AntTable;
